module.exports = __webpack_public_path__ + "static/group2_5-e38c86a41e2c82df0d8dfd9a794cefd9.webp";